import Immutable from 'immutable';
import moment from 'moment';

import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  id: string,
  userName: string,
  creationDate: moment.Moment | null,
  grantedBy: string,
  tags: string
} = {
  id: '',
  userName: '',
  creationDate: null,
  grantedBy: '',
  tags: ''
};

class Token extends Immutable.Record(Content) {
  static fromJS (json: object): Token {
    return ClassFactory.createFromJson(json, Token);
  }

  get name (): string {
    return this.userName;
  }
}

export default Token;
